/* eslint-disable @typescript-eslint/naming-convention */
import { ITheme } from "@swiggy-private/dls-web-common/dist/components/types";
import { AIP_POSITIVE_GRADIENT, ThemeOverrideResolver } from "@swiggy-private/checkout-core";
import { POP_COLORS } from "./TurboPayment";

export const TURBO_PAY_BUTTON_THEME_FLOW = {
    BAU: "BAU",
    POP: "POP",
    AIP: "AIP",
} as const;

export type TurboPayButtonThemeFlow = typeof TURBO_PAY_BUTTON_THEME_FLOW[keyof typeof TURBO_PAY_BUTTON_THEME_FLOW];

export const TURBO_PAY_BUTTON_THEME_OVERRIDES: Record<TurboPayButtonThemeFlow, ThemeOverrideResolver> = {
    [TURBO_PAY_BUTTON_THEME_FLOW.BAU]: (theme: ITheme) => ({
        positive: theme.colors[theme.colorMode].special_positive,
    }),
    [TURBO_PAY_BUTTON_THEME_FLOW.POP]: {
        positive: POP_COLORS.PRIMARY,
        text_Button_Primary: POP_COLORS.TEXT_PRIMARY,
        text_inverse_Highest_Emphasis: POP_COLORS.TEXT_PRIMARY,
        text_inverse_Med_Emphasis: POP_COLORS.TEXT_PRIMARY,
    },
    [TURBO_PAY_BUTTON_THEME_FLOW.AIP]: {
        positive: AIP_POSITIVE_GRADIENT,
    },
};

export const resolveTurboPayButtonThemeFlow = ({
    isQuickCheckoutEnabled,
    isPop,
}: {
    isQuickCheckoutEnabled?: boolean;
    isPop?: boolean;
}): TurboPayButtonThemeFlow => {
    if (isQuickCheckoutEnabled) {
        return TURBO_PAY_BUTTON_THEME_FLOW.AIP;
    }
    if (isPop) {
        return TURBO_PAY_BUTTON_THEME_FLOW.POP;
    }
    return TURBO_PAY_BUTTON_THEME_FLOW.BAU;
};
